import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chatter',
  templateUrl: './chatter.component.html',
  styleUrls: ['./chatter.component.css']
})
export class ChatterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
